export default __webpack_public_path__ + "static/media/perfil.a075ade5.png";